// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PageArticleDetail__latestArticles:before{border-bottom:1px solid #eaeaea;content:\"\";display:block;margin:2.5rem 0;width:100%}.PageArticleDetail__latestArticles .ArticleBox--last{margin-bottom:0}.PageArticleDetail__latestArticles .ArticleBox--last:after{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
